import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ComLoginButton from "@/components/common/buttons/ComLoginButton.vue"
import { SwitchButton } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KirjauduView' },
  __name: 'Kirjaudu',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { justify: "space-evenly" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          lg: 12,
          span: 24,
          style: {"text-align":"center","margin-bottom":"40px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              src: require('@/assets/vahtilogo.png')
            }, null, 8, ["src"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { justify: "space-evenly" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          lg: 14,
          span: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "login-card" }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Vahti Vaatimustenhallintajärjestelmä", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("p", null, "Tämä on Vahti- järjestelmän kirjautumissivu.", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, " Vahti on järjestelmä, jota käytetään terveydenhuollon rakennushankkeissa. Vahti ohjaa ja opastaa käyttäjää kirjaamaan toiminnan tiloille aiheuttamat tarpeet eli vaatimukset. ", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("p", null, " Vahdissa tilanimikkeistö on yhtenäistetty sairaanhoitopiirien käytössä olevien tilanimikkeiden pohjalta ja suunnittelualakohtainen sisältö noudattaa vakiintunutta nimikkeistöä. ", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", null, " Tiedot tallennetaan tietokantaan, mikä mahdollistaa monipuoliset hakutoiminnot sekä raportoinnin ja vertailun. ", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, " Vahti-järjestelmän omistaa Suomen sairaalatekniikan yhdistys ry (SSTY ry) Järjestelmän toteutuksesta ja ylläpidosta vastaa DataSund Oy yhteyshenkilönä toimii Jani Saine, DataSund Oy. ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, [
                  _createElementVNode("b", null, "tuki[ät]vahtihuonekortti.fi")
                ], -1)),
                _createElementVNode("p", null, [
                  _createVNode(ComLoginButton, {
                    size: "large",
                    icon: _unref(SwitchButton)
                  }, null, 8, ["icon"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      justify: "space-evenly",
      style: {"margin-top":"40px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          lg: 14,
          span: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "login-card" }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Uusien ominaisuuksien esittely", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("p", null, "Videoesittelyt Vahtiin keväällä 2025 kehitettyistä uusista ominaisuuksista.", -1)),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EYkRX9gqC01Fg48SEhG7EgEB2PC_0HlHLYsZG90Rxt6RrA?e=6OQTVG",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Edistynyt haku", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EQ1_h3Y_hlZCqAvnqD14JpoBwYX6AFHf6OOZusif_84QuA?e=KkriZy",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Useamman nimikkeen muokkaus yhdellä kertaa", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EWb1Y76Gbr1Om1WYMfcQdSUB8n3ldV-U7psH68dKQPQcmA?e=F0DKpJ",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Kalustepaketit", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EY9lWcfZKnlPsbuHufh1CC8BnoWb-qjPjAdoGMctD0Yg5A?e=Z92fCT",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Liitetiedosto nimikkeeisiin", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/EbxgQg-fefdFtmexyz6ZnFUBafBNuN_zIWbFpQih3XW1oQ?e=cVco59",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Nimikkeiden kommentointi", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_link, {
                    href: "https://tietosund-my.sharepoint.com/:v:/g/personal/jani_saine_tietosund_fi/Ebf1CT7BqY5EtkPHsVJgO6ABOY5s-deenelRgxtUtrvV7Q?e=f5CWBb",
                    type: "success",
                    underline: "always",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("Liitteet tulosteen mukana zip-paketissa", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})